interface ProgressBarProps {
  currentStep: number
  totalSteps: number
  /** Human label of the current step (already translated) */
  label?: string
  /** "Schritt {{n}} von {{total}}" (already translated) */
  counter?: string
}

export function ProgressBar({ currentStep, totalSteps, label, counter }: ProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100

  return (
    <div className="sticky top-0 z-50 bg-muted">
      <div
        className="h-[5px] bg-gray-200 w-full"
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        aria-valuenow={currentStep}
        aria-label={counter || `Step ${currentStep} of ${totalSteps}`}
      >
        <div
          className="h-full bg-primary transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      {(label || counter) && (
        <div className="max-w-2xl mx-auto px-4 py-1.5 flex items-center justify-between text-xs text-muted-foreground">
          <span className="truncate">{label}</span>
          <span className="tabular-nums shrink-0 ml-3">{counter}</span>
        </div>
      )}
    </div>
  )
}
